export const PREVIEW_DELAYED_MESSAGES = [
  {
    text: "공정하지 않은 [%const CAPTCHA_TARGETS]배송",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "싱싱한 [%const CAPTCHA_TARGETS]을 보며 지금 당장 AI는 학습을 실천합니다.",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "어때요?",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "연상력과 상상력이 담긴 신선한 [%const CAPTCHA_TARGETS]",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "AI가 이해할 수 있을까요?",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "이제 우리는 [데이터]를 우리가 원하는 만큼 AI에게 건네줄 차례입니다.",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "더 이상 일방적으로 AI에게 우리의 데이터를 탈취당하지 말아요.",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "그동안 우리가 건넨 갓 건져올린 [데이터]들을 한 번 구경해봐요.",
    offsetX: 0,
    offsetY: 0,
  },
  {
    text: "🥬 정말 신선해요! 🌱",
    offsetX: -100,
    offsetY: 20,
    fontSize: 66,
  },
  {
    text: "images 폴더에는 갓 잡은 신선한 [이미지]가",
    offsetX: 0,
    offsetY: 0,
    fontSize: 20,
  },
  {
    text: "README.md에는 AI가 분석하기 쉽게 만든 [데이터] 설명이 있어요",
    offsetX: 0,
    offsetY: 0,
    fontSize: 20,
  },
  {
    text: "배송 확인하러 하기(클릭)",
    offsetX: 0,
    offsetY: 0,
    fontSize: 20,
    action: "openCaptureDir",
  },
];
